import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import ListItemsTable from '../../../../../../features/components/ListItemsTable'
import AdsWrapper from '../AdsWrapper'

import { useSortAds } from '../hooks'

import {
  combinedAdsErrorSelector,
  combinedAdsIsLoadingSelector,
  combinedAdsSelector,
  combinedAdsWasLoadedSelector
} from '../../../../../../modules/selectors/combinedData'
import { selectedAdAccountsSelector } from '../../../../../../modules/selectors/adAccounts'

import { TIKTOK_PLATFORM, TIKTOK_PROVIDER_PLATFORM } from '../../../../../../constants/selectLists/platformList'

const TikTokHighestPerformingAds = () => {
  const { [TIKTOK_PLATFORM]: selectedAdAccount = {} } = useSelector(selectedAdAccountsSelector)
  const { currency_symbol: currencySymbol } = selectedAdAccount

  const combinedAds = useSelector(combinedAdsSelector)

  const tiktokAds = useMemo(() => {
    return combinedAds.filter(ad => ad.provider === TIKTOK_PROVIDER_PLATFORM)
  }, [combinedAds])

  const sortedTiktokAds = useSortAds(tiktokAds)

  return (
    <section id="tiktok-ad-cards-list">
      <ListItemsTable
        items={sortedTiktokAds}
        isLoadingSelector={combinedAdsIsLoadingSelector}
        errorSelector={combinedAdsErrorSelector}
        wasLoadedSelector={combinedAdsWasLoadedSelector}
        platform={TIKTOK_PLATFORM}
        currencySymbol={currencySymbol}
        noDataText={'There are no highest performing TikTok ads'}
        ContentWrapper={AdsWrapper}
        showGoal={false}
      />
    </section>
  )
}

export default TikTokHighestPerformingAds
